import { useRouter } from 'next/router';
import css from './tabListB.module.scss';
import SwiperA from './swiperA';
import KitD from './kitD';
import KitE from './kitE';
import KitF from './kitF';
import KitG from './kitG';
import KitH from './kitH';
import KitI from './kitI';
import KitK from './kitK';
import KitL from './kitL';
import KitM from './kitM';
import ListC from './listC';
import ListB from './listB';
import ListD1 from './listD/listD1';
import ListD2 from './listD/listD2';
import { useGlobal } from '@/utils/useGlobal';

export default function TabListB({ callBack }: any) {
    const { locale } = useRouter();
    const { useLang } = useGlobal();
    const { t } = useLang('ecoflowpowerkitsseries');

    const swiperAData = {
        title1: t('presale.product.tab_listB_title1'),
        title2: t('presale.product.tab_listB_title2'),
        list: [
            {
                i18n: '15m',
                src: ['/video/mm100m/small.webm', '/video/mm100/small.mp4'],
                class: 'offGrid-video-1',
            },
            {
                i18n: '30m',
                src: ['/video/mm100m/middle.webm', '/video/mm100/middle.mp4'],
                class: 'offGrid-video-2',
            },
            {
                i18n: '45m',
                src: ['/video/mm100m/large.webm', '/video/mm100/large.mp4'],
                class: 'offGrid-video-3',
            },
        ],
    };

    return (
        <div className={`${css.tabListB} tabListB`}>
            <SwiperA data={swiperAData} customClass="right-swiper" pagingClass="right-paging" tab="off-grid" />
            <KitD />
            {!['au'].includes(locale) && <KitE type="offGrid" callBack={callBack} customClass="kitE-offGrid" />}
            <KitF type="offGrid" />
            <KitG type="offGrid" customClass="kitG-offGrid" />
            <KitH type="offGrid" customClass="kitH-offGrid" videoClass1="grid-video1" videoClass2="grid-video2" />
            <KitK />
            <KitI type="offGrid" />
            <ListB callBack={callBack} customClass="listB-offGrid" type="offGrid" />
            <KitL callBack={callBack} active="kitL" />
            <KitM callBack={callBack} active="kitM" />
            <ListC callBack={callBack} type="offGrid" active="listC" />
            <ListD1 callBack={callBack} active="listD1" />
            <ListD2 callBack={callBack} active="listD2" />
        </div>
    );
}
